var React = require('react');

function Rectangle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#FFF"},React.createElement("path",{"d":"M1262 1360H1272V1890H1262z","transform":"translate(-1262 -1360) matrix(-1 0 0 1 2534 0)"}))));
}

Rectangle.defaultProps = {"width":"10","height":"530","viewBox":"0 0 10 530"};

module.exports = Rectangle;

Rectangle.default = Rectangle;
